<template>
  <div class="floor-map" v-loading.fullscreen.lock="loading" v-if="$router.currentRoute.path == '/floormap'">

    <div class="top-controls do-not-print" :style="{display : (!viewHistoricalController && !summaryReportMode) ? 'flex' : 'none' }">
      <template v-if="sites.length === 1">
        Unit:
        <el-select v-model="selectedUnit" placeholder="Unit" v-on:change="unitUpdated">
          <el-option label="Not Selected" :value="0"> </el-option>
          <el-option v-for="item in units" :key="item.id" :label="item.displayText" :value="item.id">
            <span style="float: left">{{ item.displayText }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </template>
      <template v-if="sites.length > 1">
        <location-filter :filterGroupLabelVisible="false" @update:filter="locationFilterUpdate"></location-filter>
      </template>
      <el-button data-testid="view-historical-infections" v-if="selectedUnit != 0 && !viewHistoricalController" @click="historicalFloorMapVisible = true">View Historical Infections</el-button>
      <el-button data-testid="view-summary-report" v-if="selectedUnit != 0" @click="summaryReportSettingsVisible = true">View Summary Report</el-button>
    </div>
    <div v-if="summaryReportMode">
      <el-button data-testid="new-summary-report" v-if="selectedUnit != 0" @click="summaryReportSettingsVisible = true">New Summary Report</el-button>
      <el-button data-testid="exit-summary-report"  @click="exitSummaryReport">Exit Summary Report</el-button>
    </div>

    <!-- DETAIL -->
    <div v-if="viewHistoricalController" class="controller">
      <el-row>
        <el-button data-testid="historical-settings" class="historicalSettings" size="small" @click="historicalFloorMapVisible = true">Settings</el-button>
        <el-button data-testid="playback-stop" class="controller-buttons" @click="sliderButtonPress('stop')"
          ><svg xmlns="http://www.w3.org/2000/svg" :height="controllerButtonSize" viewBox="0 0 24 24" :width="controllerButtonSize" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M16 8v8H8V8h8m2-2H6v12h12V6z" /></svg>
        </el-button>
        <el-button data-testid="playback-backward" class="controller-buttons" @click="sliderButtonPress('backward')">
          <svg xmlns="http://www.w3.org/2000/svg" :height="controllerButtonSize" viewBox="0 0 24 24" :width="controllerButtonSize" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0l-8.5 6 8.5 6V6z" />
          </svg>
        </el-button>
        <el-button data-testid="playback-play" class="controller-buttons" @click="sliderButtonPress('play')" size="small" v-if="!intervalValue">
          <svg xmlns="http://www.w3.org/2000/svg" :height="controllerButtonSize" viewBox="0 0 24 24" :width="controllerButtonSize" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
          </svg>
        </el-button>
        <el-button data-testid="playback-pause" class="controller-buttons" @click="sliderButtonPress('pause')" size="small" v-if="intervalValue">
          <svg xmlns="http://www.w3.org/2000/svg" :height="controllerButtonSize" viewBox="0 0 24 24" :width="controllerButtonSize" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
            </svg>
        </el-button>
        <el-button data-testid="playback-forward" class="controller-buttons" @click="sliderButtonPress('forward')">
          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" :height="controllerButtonSize" viewBox="0 0 24 24" :width="controllerButtonSize" fill="#000000">
            <g>
              <rect fill="none" height="24" width="24" />
              <rect fill="none" height="24" width="24" />
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <g />
              <path d="M15,9.86L18.03,12L15,14.14V9.86 M6,9.86L9.03,12L6,14.14V9.86 M13,6v12l8.5-6L13,6L13,6z M4,6v12l8.5-6L4,6L4,6z" />
            </g>
            </svg>
        </el-button>
        <span class="current-date-display"> Current Date: {{ formatSliderTooltip(sliderDate) }}</span>
        <el-button data-testid="close-historical" class="close-historical-button" type="text" size="small" @click="resetFloormap()">
          <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" /></svg>
      </el-button>
      </el-row>
      <el-row>
        <el-col class="edge-dates" :span="3">
          {{ formatSliderTooltip(0) }}
        </el-col>
        <el-col :span="18">
          <el-slider v-model="sliderDate" :min="0" :max="dateRangeLength" :step="1" :format-tooltip="formatSliderTooltip" :show-tooltip="false"> </el-slider>
        </el-col>
        <el-col class="edge-dates" :span="3">
          {{ formatSliderTooltip(dateRangeLength) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col> </el-col>
      </el-row>
    </div>
    <div class="legend">
      <div class="uti">UTI</div>
      <div class="respiratory">Respiratory</div>
      <div class="gi">GI</div>
      <div class="skin">Skin & Soft tissue</div>
    </div>
    <div class="floor" ref="floor" v-if="ready">
      <hcx-floormap ref="floormap"></hcx-floormap>
    </div>

    <!-- Historical Floor Map -->
    <el-dialog title="Historical Floor Map Settings" :show-close="false" :visible="historicalFloorMapVisible" size="small">
      <div class="settings-details">
        <el-form @submit.prevent="onSubmit" ref="observerForm">
          <el-form-item label="Date Range:" :rules="{ required: true }">
            <el-date-picker v-model="historicalDateRange" type="daterange" :format="$configStore.datePickerDateFormat()" :picker-options="pickerOptions" range-separator=" ~ "> </el-date-picker>
          </el-form-item>
          <el-form-item label="Player Speed (Seconds Per Interval):">
            <el-input-number v-model="controllerSpeed" :min="1" size="small"> </el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button data-testid="cancel-historical-settings" @click="historicalFloorMapVisible = false">Cancel</el-button>
        <el-button data-testid="play-historical" type="primary" :disabled="historicalDateRange[0] == null" @click="startHistoricalFloormap()">Play</el-button>
      </span>
    </el-dialog>

    <!-- Summary report date range -->
    <el-dialog title="Summary Report Settings" :show-close="false" :visible="summaryReportSettingsVisible" size="small">
      <div class="settings-details" v-loading="summaryReportSettingsBusy">
        <el-form @submit.prevent="onSubmit">
          <el-form-item label="Date Range:" :rules="{ required: true }">
            <el-date-picker v-model="historicalDateRange" type="daterange" :format="$configStore.datePickerDateFormat()" :picker-options="pickerOptions" range-separator=" ~ "> </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button data-testid="cancel-summary-report" @click="summaryReportSettingsVisible = false">Cancel</el-button>
        <el-button data-testid="run-summary-report" type="primary" :disabled="historicalDateRange[0] == null" @click="generateSummaryReport()">Run Report</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import auth from "../auth";
import api from "../services/restClient";

import moment from "moment";
import { Loading } from "element-ui";
import LocationFilter from "../components/LocationFilter/LocationFilter";
import transformer from "@/transformer";
import util from "@/util";

export default {
  name: "floormap",
  components: {
    "location-filter": LocationFilter
  },
  data: function() {
    return {
      // historical floor plan data
      historicalDateRange: [null],
      dateRangeLength: 1,
      sliderDate: 1,
      viewHistoricalController: false,
      controllerButtonSize: "15px",
      initialCaseDict: {},
      intervalValue: null,
      controllerSpeed: 1,
      // HFP Data
      ready: false,
      fixClick: false,
      historicalFloorMapVisible: false,
      summaryReportSettingsVisible: false,
      summaryReportSettingsBusy: false,
      summaryReportMode: false,
      filterSelectionVisible: false,
      loading: false,
      firstLoad: false,
      currentDate: new Date(),
      cases: [],
      precautions: [],
      beds: {},
      symptomTypes: [],
      symptoms: [],
      searchNameInput: "",
      clients: {},
      infCases: {},
      clientList: [],
      clientService: {},
      symptomTypeMap: {},
      customSymptomTypeMap: {},
      origins: [],
      outcomes: [
        {
          value: "Chronic",
          label: "Chronic"
        },
        {
          value: "Deceased",
          label: "Deceased"
        },
        {
          value: "Discharged",
          label: "Discharged"
        },
        {
          value: "Hospitalized",
          label: "Hospitalized"
        },
        {
          value: "Resolved",
          label: "Resolved"
        }
      ],
      statusImageMap: {
        GI: "bug2",
        UTI: "bug3",
        Respiratory: "bug1",
        Skin: "bug4"
      },
      allFilters: {
        dateRange: true,
        unit: true,
        infSite: true,
        status: true,
        origin: true,
        treatment: false,
        precaution: false,
        organism: false,
        resolution: false,
        familyNotified: false,
        nextOfKinNotified: false,
        physicianNotified: false,
        staffOrRes: false,
        firstName: false,
        lastName: false
      },
      siteAndTypeOptionsSelection: [0],
      caseActiveTab: "1",
      selectedClientStatus: 1,
      selectedCase: null,
      selectedClient: null,
      selectedUnit: 0,
      selectedUnitDetail: null,
      selectedOrigin: 0,
      selectedStatus: 0,
      selectedTreatment: 0,
      selectedPrecautions: 0,
      selectedOrganisms: 0,
      selectedResolved: 0,
      selectedFamilyNotified: 0,
      selectedNextOfNotified: 0,
      selectedPhysicianNotified: 0,
      selectedClientType: 0,
      selectedSite: 0,
      selectedFirstName: "",
      selectedLastName: "",
      selectedCaseToDelete: null,
      dialogFormVisible: false,
      newCaseDialogFormVisible: false,
      includeDischargedClient: false,
      dialogConfirmDeleteVisible: false,
      newCase: {
        client: null,
        symptoms: [],
        error: null,
        subtypeString: ""
      },
      subStatusMap: {
        GI: ["Noro Virus", "CDI", "GE"],
        UTI: ["ABUTI", "SUTI", "ASB"],
        Respiratory: ["Upper/Common Cold", "Lower/Pnem/Bron", "Flu - Influezna Like", "SINU"]
      },
      symptomDetailPage: 1,
      symptomDetailPageSize: 1000,
      symptomDetailPageTotal: 0,
      symptomDetailTotal: 0,
      filterDateRange: "",
      filteredSite: {},
      filterPeriods: "week",
      filterSymptomTypes: [],
      filteredSiteSubType: 0,
      siteAndTypeOptions: [],
      availableUnits: [],
      organisms: [],
      treatments: [],
      units: [],
      unitMap: {},
      sites: [],
      organization: [],
      graphPeriodFilter: "By Week",
      graphDisplayFilter: "By Infection Site",
      pickerOptions: {
        shortcuts: util.datepickerShortcuts()
      }
    };
  },
  watch: {
    sliderDate: function(val) {
      this.displayHistoricalFloormap(val);
    },
    selectedUnit: function() {
      if (this.viewHistoricalController) {
        this.viewHistoricalController = false;
      }
    }
  },
  methods: {
    // Leaflet keeps the size it measured on screen, so print the floor box at that same size and scale it to fit the page
    onBeforePrint: function() {
      const floor = this.$refs.floor;
      if (!floor) return;
      const rect = floor.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      floor.style.setProperty("--print-floor-width", rect.width + "px");
      floor.style.setProperty("--print-floor-height", rect.height + "px");
      floor.style.setProperty("--print-floor-zoom", Math.min(1, 700 / rect.width, 900 / rect.height));
      floor.style.setProperty("--print-floor-zoom-landscape", Math.min(1, 950 / rect.width, 620 / rect.height));
    },
    onAfterPrint: function() {
      const floor = this.$refs.floor;
      if (!floor) return;
      floor.style.removeProperty("--print-floor-width");
      floor.style.removeProperty("--print-floor-height");
      floor.style.removeProperty("--print-floor-zoom");
      floor.style.removeProperty("--print-floor-zoom-landscape");
    },
    generateSummaryReport: async function() {
      const floorMap = this.$refs.floormap;
      this.summaryReportSettingsBusy = true;
      const params = {
        page: 1,
        size: 1000,
        unitIds: [this.selectedUnit],
        isFloorMap: true,
        infectionSites: ["GI", "Respiratory", "UTI", "Skin", "SSI"],
        onsetDateFrom: moment(this.historicalDateRange[0]).startOf('day').format("YYYY-MM-DDTHH:mm:ssZ"),
        onsetDateTo: moment(this.historicalDateRange[1]).endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
      };
      if (this.filteredSiteSubType && this.filteredSiteSubType !== 0) {
        params.infectionSiteSubTypes = [this.filteredSiteSubType];
      }
      const cases = await this.$http.post(`${window.CONFIG.infection_api}/search`, params).then((response) => response.body.content.map(transformer.mapInfectionCaseToLegacyModel));

      const currentUnitDetails = util.copyJson(this.selectedUnitDetail);

      for (let room of currentUnitDetails.rooms) {
        for (let bed of room.beds) {
          bed.cases = cases.filter(({bedId}) => bed.id === bedId);
        }
      }

      floorMap.unit = currentUnitDetails;

      this.summaryReportSettingsBusy = false;
      this.summaryReportSettingsVisible = false;
      this.summaryReportMode = true;
    },
    exitSummaryReport: function () {
      this.summaryReportMode = false
      this.resetFloormap();

    },
    formatSliderTooltip: function(val) {
      return moment(this.historicalDateRange[0])
        .add(val, "days")
        .format(this.$configStore.dateFormat());
    },
    sliderButtonPress: function(event) {
      if (event === "play") {
        this.intervalValue = setInterval(() => {
          console.log("sliderDate++");
          if (this.sliderDate < this.dateRangeLength) {
            this.sliderDate++;
          } else {
            this.sliderButtonPress("pause");
          }
        }, this.controllerSpeed * 1000);
      }
      if (event === "pause" && this.intervalValue) {
        clearInterval(this.intervalValue);
        this.intervalValue = null;
      }
      if (event === "forward" && this.sliderDate < this.dateRangeLength) {
        this.sliderDate++;
      }
      if (event === "backward" && this.sliderDate > 0) {
        this.sliderDate--;
      }
      if (event === "stop") {
        this.sliderDate = 0;
        this.sliderButtonPress("pause");
      }
    },
    resetFloormap: function() {
      this.sliderButtonPress("pause");
      this.viewHistoricalController = false;
      this.unitUpdated();
    },
    fetchHistoricalFloorMapCases: async function() {
      const start = moment(this.historicalDateRange[0]).toDate();
      const to = moment(this.historicalDateRange[1])
        .hours(23)
        .minutes(59)
        .seconds(59)
        .toDate();
      const params = {
        page: 1,
        size: 1000,
        unitIds: [this.selectedUnit],
        isFloorMap: true,
        infectionSites: ["GI", "Respiratory", "UTI", "Skin", "SSI"],
        inclusiveOnsetDateFrom: start,
        inclusiveOnsetDateTo: to
      };
      if (this.filteredSiteSubType && this.filteredSiteSubType !== 0) {
        params.infectionSiteSubTypes = [this.filteredSiteSubType];
      }
      const response = await this.$http.post(`${window.CONFIG.infection_api}/search`, params);
      return response;
    },
    startHistoricalFloormap: async function() {
      console.log("startHistoricalFloormap");
      this.sliderButtonPress("pause");
      var after = moment(this.historicalDateRange[0]).toDate();
      var before = moment(this.historicalDateRange[1]);
      this.dateRangeLength = before.diff(after, "days");
      this.historicalFloorMapVisible = false;
      this.viewHistoricalController = true;
      this.initialCaseDict = {};
      var vm = this;

      const casesResponse = await this.fetchHistoricalFloorMapCases();
      if (casesResponse.body.totalElements) {
        const cases = casesResponse.body?.content.map(transformer.mapInfectionCaseToLegacyModel);
        cases.forEach(c => {
          if (!this.initialCaseDict[c.bedId]) {
            this.initialCaseDict[c.bedId] = [c];
          } else {
            this.initialCaseDict[c.bedId].push(c);
          }
        });
      } else {
        console.log("no content");
        vm.cases = [];
      }

      const useNewEndpoints = await this.getFeatureFlag('IPAC_UNITS_API_ROLLOUT');
      const url = useNewEndpoints ? `${window.CONFIG.legacy_facade_api}/units/${this.selectedUnit}` : `${window.CONFIG.api}/units/${this.selectedUnit}`;

      const response = await this.$http.get(url);
      if (response.body) {
        vm.selectedUnitDetail = response.body;
      } else {
        console.log("no unit detail response");
      }
      console.log(vm.selectedUnitDetail);
      this.sliderDate = 0;
      this.sliderButtonPress("play");
    },
    displayHistoricalFloormap: async function(dateValue) {
      let floorMap = this.$refs.floormap;
      let vm = this;
      let currentUnitDetails = {};
      currentUnitDetails = JSON.parse(JSON.stringify(vm.selectedUnitDetail));

      // sort by onset and resolution date
      const currentSliderDate = moment(this.historicalDateRange[0])
        .add(dateValue, "days")
        .hours(23)
        .minutes(59)
        .seconds(59);
      let currentCases = {};
      console.log("slider date " + moment(currentSliderDate).toDate());
      for (let [bedId, cases] of Object.entries(vm.initialCaseDict)) {
        const relevantCases = this.findRelevantCases([...cases], currentSliderDate);
        currentCases[bedId] = relevantCases;
      }
      for (let r of currentUnitDetails.rooms) {
        for (let b of r.beds) {
          b.cases = [];
          if (currentCases[b.id] && currentCases[b.id].length > 0) {
            b.client = currentCases[b.id][0].client;
            b.photo = vm.clientPhoto(b.client);
            b.cases = [...currentCases[b.id]];
          }
        }
      }
      console.log(currentUnitDetails);
      floorMap.unit = currentUnitDetails;
    },
    findRelevantCases(cases, currentDate) {
      // filter out resolved cases where resolutionDate is before currentDate
      const activeCases = cases.filter(c => {
        if (c.resolutionDate) {
          return moment(c.resolutionDate).isSameOrAfter(currentDate);
        }
        return true;
      });

      // find case with onSetDate closest to currentDate
      const closestCase = activeCases.reduce((closest, currentCase) => {
        const currentCaseDate = moment(currentCase.onSetDate);
        if (currentCaseDate.isSameOrBefore(currentDate)) {
          if (!closest) return currentCase;
          const closestDate = moment(closest.onSetDate);
          return currentCaseDate.isAfter(closestDate) ? currentCase : closest;
        }
        return closest;
      }, null);

      // filter active cases array only include cases with the same clientId as the closest case
      const resultCases = closestCase ? activeCases.filter(c => c.clientId === closestCase.clientId) : [];
      return resultCases;
    },
    updateFloormap: async function() {
      console.log("updateFloormap");
      console.log(this.selectedUnit);
      console.log(this.sites);
      let floorMap = this.$refs.floormap;
      let vm = this;
      let u = this.selectedUnit;
      if (floorMap && u) {

        const useNewEndpoints = await this.getFeatureFlag('IPAC_UNITS_API_ROLLOUT');

        this.$http.get(window.CONFIG.api + "/unit/" + u + "/mapimage/base64").then(async function(response) {
          floorMap.image = "data:image/png;base64," + response.bodyText;
          if (!vm.selectedUnitDetail || u !== vm.selectedUnitDetail.id) {
            if (vm.unitMap[u] && vm.unitMap[u].rooms) {
              vm.selectedUnitDetail = vm.unitMap[u];
            } else {

              const url = useNewEndpoints ? `${window.CONFIG.legacy_facade_api}/units/${u}` : `${window.CONFIG.api}/units/${u}`;

              let response = await this.$http.get(url);
              if (response.body) {
                vm.unitMap[u] = response.body;
                vm.selectedUnitDetail = response.body;
              }
            }
          }
          for (let r of vm.selectedUnitDetail.rooms) {
            for (let b of r.beds) {
              if (b.occId) {
                b.client = vm.clients[b.occId];
                b.photo = vm.clientPhoto(b.client);
                let response = await this.$http.get(`${window.CONFIG.legacy_facade_api}/clients/${b.occId}/symptomDetails?resolved=false`);
                b.cases = response.body || null;
                if (b.cases) {
                  console.log(JSON.stringify(b.cases, " ", 2));
                }
              }
            }
          }
          floorMap.unit = vm.selectedUnitDetail;
          vm.$nextTick(function() {
            vm.loading = false;
            vm.firstLoad = true;
            console.log("show loading", vm.loading);
          });
        });
      }
    },
    filterUpdated: function(o) {
      this.selectedUnit = o.unit;
      this.selectedSite = o.site;
      this.availableUnits = o.units || [];
      this.availableFacs = o.sites ? o.sites : 0;
      this.loadCases();
    },
    updatePersonalNotes(newNote) {
      console.log(newNote);
      if (this.clients[this.selectedClient.clientId]) {
        var clientData = this.clients[this.selectedClient.clientId];
        clientData.notes.splice(0, 0, newNote);
      }
    },
    handleChange(value) {
      // console.log(value)
      this.filteredSite = value[0];
      this.filteredSiteSubType = value[1] || 0;

      this.symptomTypeUpdated(value[0]);
    },
    getsubStatusMap: function(caseData) {
      // console.log(caseData)
      if (caseData && caseData.symptomType && caseData.symptomType.subTypes) {
        // console.log(this.subStatusMap[caseData.symptomType.text])
        // console.log('getsubStatusMap subtypes')
        return caseData.symptomType.subTypes;
      }

      // console.log('getsubStatusMap')
      return [];
    },
    buildParam: function() {
      var after = this.filterDateRange[0] || new Date();
      var before = this.filterDateRange[1] || new Date();

      after = moment(after)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .toDate();
      before = moment(before)
        .hours(23)
        .minutes(59)
        .seconds(59)
        .toDate();

      var rUrl = "start=" + encodeURIComponent(after) + "&end=" + encodeURIComponent(before);
      rUrl = rUrl + "&types=" + this.filterSymptomTypes;

      if (this.filteredSiteSubType !== 0) {
        rUrl = rUrl + "&subType=" + this.filteredSiteSubType;
      }

      if (this.selectedOrigin !== 0) {
        rUrl = rUrl + "&origin=" + this.selectedOrigin;
      }

      if (this.selectedStatus !== 0) {
        rUrl = rUrl + "&confirmed=" + (this.selectedStatus === 1 ? "true" : "false");
      }

      if (this.selectedPrecautions !== 0) {
        rUrl = rUrl + "&precaution=" + this.selectedPrecautions;
      }

      if (this.selectedOrganisms !== 0) {
        rUrl = rUrl + "&organism=" + this.selectedOrganisms;
      }

      if (this.selectedResolved !== 0) {
        rUrl = rUrl + "&resolved=" + (this.selectedResolved === 1 ? "true" : "false");
      }

      if (this.selectedFamilyNotified !== 0) {
        rUrl = rUrl + "&familyNotified=" + (this.selectedFamilyNotified === 1 ? "true" : "false");
      }

      if (this.selectedNextOfNotified !== 0) {
        rUrl = rUrl + "&nextOfNotified=" + (this.selectedNextOfNotified === 1 ? "true" : "false");
      }

      if (this.selectedPhysicianNotified !== 0) {
        rUrl = rUrl + "&physicianNotified=" + (this.selectedPhysicianNotified === 1 ? "true" : "false");
      }

      if (this.selectedClientType !== 0) {
        rUrl = rUrl + "&clientType=" + (this.selectedClientType === 1 ? "Client" : "Staff");
      }

      if (this.selectedFirstName !== "") {
        rUrl = rUrl + "&firstName=" + this.selectedFirstName;
      }

      if (this.selectedLastName !== "") {
        rUrl = rUrl + "&lastName=" + this.selectedLastName;
      }

      if (this.selectedTreatment !== 0) {
        rUrl = rUrl + "&treatmentId=" + this.selectedTreatment;
      }

      if (this.selectedClientStatus !== 0) {
        rUrl = rUrl + "&clientActive=" + (this.selectedClientStatus === 1 ? "true" : "false");
      }

      if (Array.isArray(this.availableUnits) && this.availableUnits.length > 0) {
        rUrl = rUrl + "&units=" + this.availableUnits;
      }

      if (this.selectedSite > 0) {
        rUrl = rUrl + "&facIds=" + [this.selectedSite];
      } else if (this.availableFacs !== 0 && Array.isArray(this.availableFacs)) {
        rUrl = rUrl + "&facIds=" + this.availableFacs;
      }

      console.log(rUrl);
      return rUrl;
    },
    loadCases: function(callback) {
      console.log("loadCases");
      if (!this.loading) {
        this.loading = true;
        console.log("show loading", this.loading);
      }

      if (this.selectedUnit === 0) {
        this.loading = false;
        console.log("show loading", this.loading);
        return;
      }

      if (callback) {
        callback();
      }
    },
    clientName: function(symptomDetail) {
      var clientData = symptomDetail.client;
      this.clients[symptomDetail.clientId] = clientData;
      return this.getClientName(clientData);
    },
    getClientName: function(clientData) {
      var firstName = clientData.firstName ? clientData.firstName + " " : "";
      var middleName = clientData.middleName ? clientData.middleName + " " : "";
      var lastName = clientData.lastName ? clientData.lastName : "";

      // console.log(JSON.stringify(clientData, ' ', 2))
      return firstName + middleName + lastName;
    },
    nameFilter: function(cases) {
      var vm = this;
      return cases.filter(function(detail) {
        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase());
      });
    },
    reloadPage: function(page) {
      if (this.symptomDetailPage !== page) {
        this.symptomDetailPage = page;
        if (this.firstLoad) {
          this.loadCases();
        }
      }
    },
    loadImage: function(detail, callback) {
      var vm = this;
      if (this.clients[detail.clientId] || this.clients[detail.clientId] === false) {
        callback();
        return;
      }
      this.clients[detail.clientId] = false;
      this.$http.get(window.CONFIG.legacy_facade_api + "/clients/" + detail.clientId).then(
        response => {
          // console.log(JSON.stringify(response.body, ' ', 2))
          vm.$set(vm.clients, detail.clientId, response.body);
          vm.$forceUpdate();
          callback();
        },
        response => {
          // error
          callback();
        }
      );
    },
    statusImage: function(detail) {
      var result = "";
      var filename;
      if (detail.symptomType) {
        filename = this.statusImageMap[detail.symptomType];
        if (!detail.confirmed) {
          filename = filename + "s";
        }
        result = "/static/" + filename + ".png";
      }

      if (result === "") {
        filename = "bug4";
        if (!detail.confirmed) {
          filename = filename + "s";
        }
        result = "/static/" + filename + ".png";
      }

      return result;
    },
    tagType: function(type) {
      if (type.colorCode === "0") {
        return "success";
      } else if (type.colorCode === "1") {
        return "primary";
      } else if (type.colorCode === "2") {
        return "warning";
      } else if (type.colorCode === "3") {
        return "danger";
      }
      return "gray";
    },
    selectedRow: function(row, event, column) {
      if (column.property === "active") {
        return;
      }

      this.symptoms = JSON.parse(JSON.stringify(this.symptoms));
      this.selectedCase = JSON.parse(JSON.stringify(row));
      this.selectedClient = this.selectedCase.client;
      if (!this.selectedCase.outcome) {
        this.selectedCase.outcome = 0;
      }

      if (!this.selectedCase.origin) {
        this.selectedCase.origin = "Not Selected";
      }

      var vm = this;
      vm.caseActiveTab = "1";
      vm.$nextTick(function() {
        // console.log(vm.caseActiveTab)
        vm.dialogFormVisible = true;
      });
    },
    dateRangeUpdated: function(value) {
      let end = new Date();
      let start = new Date();
      if (!value) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      } else {
        start = moment(value.split("~")[0].trim())
          .hour(0)
          .minute(0)
          .second(0)
          .toDate();
        end = moment(value.split("~")[1].trim())
          .hour(23)
          .minute(59)
          .second(59)
          .toDate();
      }
      this.filterDateRange = [start, end];

      if (this.firstLoad) {
        this.loadCases();
      } else {
        this.loadCases(() => {
          this.updateFloormap();
        });
      }
    },
    unitUpdated: function(value) {
      console.log("unitUpdated");
      this.loadCases(() => {
        this.updateFloormap();
      });
    },
    originUpdated: function(value) {
      if (value === 0) {
        this.filterOrigin = null;
      } else {
        this.filterOrigin = value;
      }
      // console.log('originUpdated:' + value)
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    precautionUpdated: function(value) {
      // console.log('precautionUpdated: ', +value)
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    organismsUpdated: function(value) {
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    resolvedUpdated: function(value) {
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    confirmStatusUpdated: function(value) {
      // console.log('confirmStatusUpdated:' + value)
      if (value === 0) {
        this.filterConfirmStatus = null;
      } else {
        this.filterConfirmStatus = value === 1 ? "true" : "false";
      }

      if (this.firstLoad) {
        this.loadCases();
      }
    },
    symptomTypeUpdated: function(value) {
      var vm = this;
      var sypmtomTypeFilter = [];
      // this.filteredSiteSubType = 0
      if (this.symptomTypes) {
        this.symptomTypes.forEach(function(s, i) {
          if (vm.filteredSite === 0 || vm.filteredSite.type === s.type) {
            sypmtomTypeFilter.push(s.type);
          }
        });
      }

      this.filterSymptomTypes = sypmtomTypeFilter;
      // console.log(JSON.stringify(this.filterSymptomTypes))
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    symptomSubTypeUpdated: function(value) {
      if (this.firstLoad) {
        this.loadCases();
      }
    },
    organismById: function(organId) {
      var organName = "Not Selected";
      if (organId === 0) {
        return organName;
      }

      this.organisms.forEach(function(o) {
        if (o.id === organId) {
          organName = o.name;
        }
      });

      return organName;
    },
    treatmentById: function(treatmentId) {
      var name = "Not Selected";
      if (treatmentId === 0) {
        return name;
      }

      this.treatments.forEach(function(t) {
        if (t.id === treatmentId) {
          name = t.displayText;
        }
      });

      return name;
    },
    unitById: function(unitId) {
      var unitName = "";
      this.units.forEach(function(u) {
        if (u.id === unitId) {
          unitName = u.displayText;
        }
      });

      return unitName;
    },
    originById: function(originId) {
      var originName = "Not Selected";
      this.origins.forEach(function(o) {
        if (o.value === originId && o.value !== 0) {
          originName = o.label;
        }
      });
      return originName;
    },
    unitByName: function(unitName) {
      var unit = null;
      this.units.forEach(function(u) {
        if (u.displayText === unitName) {
          unit = u;
        }
      });

      return unit;
    },
    precautionById: function(precautionId) {
      var name = "";
      this.precautions.forEach(function(p) {
        if (p.id === precautionId) {
          name = p.displayText;
        }
      });

      return name;
    },
    clientPhoto: function(client) {
      if (client && client.photo) {
        var f = client.photo;
        if (f.indexOf("/") !== -1) {
          return window.CONFIG.api + "/" + f + "?access_token=" + auth.getToken();
        }

        return "/static/" + (client.photo ? client.photo : "user") + ".png";
      }

      return "/static/user.png";
    },
    canSave: function(symptomDetail) {
      var canSave = false;
      symptomDetail.symptoms.forEach(function(s) {
        if (symptomDetail.symptomType === s.classType) {
          canSave = true;
        } else if (symptomDetail.infectionSite === s.classType) {
          canSave = true;
        }

        // console.log('- canSave ' + symptomDetail.symptomType + '- ' + s.classType)
        // console.log(symptomDetail)
        // console.log(s)
        // console.log('symptomDetail.infectionSite: ' + symptomDetail.infectionSite)
      });

      // console.log('canSave ' + (canSave ? 'Yes' : 'NO'))

      return canSave;
    },
    saveSymtomDetail: function(symptomDetail, callback) {
      var vm = this;
      console.log(symptomDetail.otherSymptoms);
      let otherSymptoms = symptomDetail.otherSymptoms ? symptomDetail.otherSymptoms.slice() : [];
      let sId = symptomDetail.id;

      api.updateSymptomDetail(symptomDetail, function() {
        api.createCustomSymptomsExt(
          {
            symptomDetailId: sId,
            otherSymptoms: otherSymptoms
          },
          r => {
            vm.loadCases();
            vm.dialogFormVisible = false;
            vm.selectedCase = null;
            console.log(r);
            if (callback) {
              callback();
            }
          }
        );
      });
    },
    reverse: function(array) {
      return array.slice().reverse();
    },
    isStaff: function(client) {
      if (client) {
        return client.clientType === "Staff";
      } else {
        return false;
      }
    },
    createNewCase: function() {
      this.newCaseDialogFormVisible = true;
      this.newCaseDialogFormVisible = false;
      this.newCase = {
        client: null,
        location: null,
        symptoms: [],
        symptomType: null,
        origin: "",
        subtypeString: "",
        onSetDate: new Date(),
        confirmed: false,
        error: null,
        primarySelection: ""
      };
      this.newCaseDialogFormVisible = true;
    },
    addSymptoms: function(newCase) {
      var vm = this;
      if (!newCase.client) {
        vm.newCase.error = "Please choose resident.";
        return;
      }

      if (!newCase.symptomType) {
        vm.newCase.error = "No infection site selected.";
        return;
      }
      var symptomList = [];
      var customSymptomList = [];
      var validSymptomList = !newCase.symptomType.requireSymptoms;
      if (validSymptomList == null) {
        return;
      }
      var loadingInstance = Loading.service({ fullscreen: true });
      console.log("show loading");
      var first = true;
      this.symptoms.forEach(function(d) {
        newCase.symptoms.forEach(function(s) {
          if (s.custom) {
            if (first) {
              customSymptomList.push(s);
            }
          } else if (d.id === s.id) {
            symptomList.push(d);
            if (d.classType === newCase.symptomType.type) {
              validSymptomList = true;
            }
          }
        });
        first = false;
      });

      if (!validSymptomList) {
        vm.newCase.error = "At least one " + vm.newCase.symptomType.displayText + " symptom is required.";
        this.$nextTick(() => {
          loadingInstance.close();
        });
        return;
      }
      // console.log(this.clientList)
      var newSymptomDetail = {
        facId: 0,
        unitId: newCase.client.unitId,
        bedId: 0,
        physicianId: 0,
        onSetDate: newCase.onSetDate.getTime(),
        symptoms: symptomList,
        symptomType: newCase.symptomType.type,
        status: null,
        clientId: newCase.client.id,
        client: newCase.client,
        organismId: 0,
        treatmentId: 0,
        resolved: false,
        confirmed: newCase.confirmed,
        active: true,
        familyNotified: false,
        nextOfNotified: false,
        physicianNotified: false,
        origin: newCase.origin,
        notes: [],
        subtypeString: newCase.subtypeString
      };

      if (!newCase.symptomType.allowedToMobile) {
        newSymptomDetail.symptomType = null;
        newSymptomDetail.infectionSite = newCase.symptomType.type;
      }

      // delete newSymptomDetail.clientId
      newSymptomDetail.symptoms.forEach(s => {
        delete s._links;
      });

      var jsonData = JSON.stringify(newSymptomDetail, 2, " ");
      // console.log('-------------!!!')
      // console.log(jsonData)
      this.$http.post(window.CONFIG.api + "/client/" + newCase.client.id + "/symptom/detail/new", jsonData).then(
        response => {
          console.log(JSON.stringify(response, 2, " "));
          var jsonData = response.body;
          let detailId = jsonData.id;
          let otherSymptoms = customSymptomList || [];
          api.createCustomSymptomsExt(
            {
              symptomDetailId: detailId,
              otherSymptoms: otherSymptoms
            },
            r => {
              console.log(r);
            }
          );
          jsonData.onSetDate = newSymptomDetail.onSetDate;
          if (newCase.primarySelection) {
            jsonData.organismId = newCase.primarySelection.id;
            jsonData.organismDetails = [{ type: "Primary", organism: newCase.primarySelection }];
          }

          vm.saveSymtomDetail(jsonData, function() {
            vm.createNewCase();
            vm.newCaseDialogFormVisible = false;
            loadingInstance.close();
          });
        },
        response => {
          // error callback
          // console.log(JSON.stringify(response, 2, ' '))
          if (response.status === 409) {
            vm.newCase.error = (vm.newCase.symptomType.text || vm.newCase.symptomType.displayText) + " case already exsits for " + vm.getClientName(vm.newCase.client);
          }
          loadingInstance.close();
        }
      );
    },
    deleteCase: function(i, row) {
      // console.log(row)
      // if (!row) {
      //   row = this.cases[i]
      // }
      this.selectedCaseToDelete = row;
      this.dialogConfirmDeleteVisible = true;
    },
    confirmDeleteCase: function() {
      if (this.selectedCaseToDelete) {
        this.selectedCaseToDelete.active = false;
        this.saveSymtomDetail(this.selectedCaseToDelete);
        this.dialogConfirmDeleteVisible = false;
      }
    },
    newSypmtomsSelected: function() {
      console.log(JSON.stringify(this.newCase.symptoms));
      // console.log(tagsEl)
      // console.log(tagsEl.nodeName)
      // console.log(tagsEl.children)

      var vm = this;
      this.$nextTick(function() {
        console.log(" --- this.$refs ---");
        console.log(vm.$refs);

        var tagsEl = vm.$refs.newcasesymptoms.$refs.tags.firstChild;
        for (var i = 0; i < tagsEl.children.length; i++) {
          var el = tagsEl.children[i];
          console.log(el.textContent);
          for (var j = 0; j < vm.symptoms.length; j++) {
            var s = vm.symptoms[j];
            if (s.custom) {
              console.log("custom skipped");
              continue;
            }
            if (el.textContent === s.displayText) {
              if (el.classList.contains("el-tag--primary")) {
                el.classList.remove("el-tag--primary");
              }
              var tagType = "el-tag--" + vm.tagType(s);
              // console.log(tagType)
              if (!el.classList.contains(tagType)) {
                el.classList.add(tagType);
              }
              break;
            }
          }
          // console.log(vm.symptoms)
        }
      });
    },
    locationFilterUpdate: function(...args) {
      const selectedUnit = this.units.filter(u => u.id === args[0].unit);
      if (selectedUnit[0]) {
        this.selectedUnit = selectedUnit[0].id;
        this.selectedSite = selectedUnit[0].siteId;
        this.loadCases(() => {
          this.updateFloormap();
        });
      }
    }
  },
  mounted: function() {
    this.clientList = this.$configStore.data.clientList || [];
    this.organization = this.$configStore.data.organization || [];
    if (this.organization[0]) {
      this.sites = this.organization[0].sites;
    } else {
      this.organization = [];
      this.sites = [];
      this.loading = false;
      console.log("show loading", this.loading);
    }
    this.dataReady = true;
    var vm = this;
    vm.sites = this.$configStore.data.sites || [];
    vm.units = (this.$configStore.data.units || []).filter((unit) => unit.archived !== true);
    vm.rooms = this.$configStore.data.rooms || [];
    vm.beds = this.$configStore.data.beds || [];
    vm.symptomTypes = this.$configStore.data.symptomTypes || [];
    // vm.customSymptomTypeMap = this.$configStore.data.customSymptomTypeMap || {}
    vm.symtpoms = this.$configStore.data.symtpoms || [];
    vm.organisms = this.$configStore.data.organisms || [];
    vm.precautions = this.$configStore.data.precautions || [];
    vm.treatments = this.$configStore.data.treatments || [];
    vm.origins = this.$configStore.data.origins || [];
    vm.loadCases();
    this.ready = true;
    window.addEventListener("beforeprint", this.onBeforePrint);
    window.addEventListener("afterprint", this.onAfterPrint);
  },
  destroyed: function() {
    this.sliderButtonPress("pause");
    window.removeEventListener("beforeprint", this.onBeforePrint);
    window.removeEventListener("afterprint", this.onAfterPrint);
  }
};
</script>


<style>
/* hcx-floormap adds Bootstrap's "@page { size: a3 }", which hides the print orientation option */
@page {
  size: auto !important;
}

.floor-map .filter-section {
      display: flex;
    margin: 0;
    padding: 0;
    height: auto;
    vertical-align: unset;
    justify-content: center;
    gap: 2rem;
}
.floor-map .filter-section > label {
  display: flex;
  flex: 0 1 auto;
  width: unset;
  gap: 0.5rem;
}
.floor-map .filter-section .filter-title-label {
  width:auto;
  display: flex;
  margin: 0;
}

.floor hcx-floormap .floor-map {
  margin: auto;
  height: 95%;
}

.floor hcx-floormap .leaflet-pane {
  transform: scale(1.2) translate(-50px, -50px);
}
</style>

<style scoped>
.floor-map {
  height: calc(100% - 1rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1rem;
  margin-top: 1rem;
}
.top-controls {
  display:flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem 2rem;
  flex-wrap: wrap;
}
.floor-map .floor {
  flex: 1 1 auto;
}
.floor-map .floor hcx-floormap {
  height: 100%;
  display: block;
}
.floor-map .floor hcx-floormap .floor-map {
  height: 100% !important;
  min-height: 600px;
  width: 100% !important;
  min-width: 600px;
}

.legend {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.legend > * {
  display:flex;
  align-items: center;
  gap: 0.25rem;
}
.legend *::before {
  display: inline-block;
  content: "";
  width: 14px;
  height: 14px;
}
.legend .uti::before {
  background-color: var(--infection-site-color-code-uti);
}
.legend .respiratory::before {
  background-color: var(--infection-site-color-code-respiratory);
}
.legend .gi::before {
  background-color: var(--infection-site-color-code-gi);
}
.legend .skin::before {
  background-color: var(--infection-site-color-code-skin);
}
.controller {
  border: 1px solid #a9a9a9;
  width: 900px;
  text-align: center;
  padding-top: 10px;
}
.historicalSettings {
  float: left;
  margin-left: 20px;
  font-size: 15px;
}

.controller-buttons {
  padding: 5px;
  float: left;
}

.current-date-display {
  margin-left: -160px;
}

.close-historical-button {
  float: right;
  margin-right: 15px;
  padding: 0;
}

.historicalButtonDiv {
  position: absolute;
  top: 10px;
  right: -300px;
}

/* In print, .right-content is static and has no fixed height, so give the map a fixed print box.
   onBeforePrint sets the screen size of the box, so Leaflet does not need to resize. */
@media print {
  .floor-map {
    height: auto;
  }
  .floor-map .floor {
    flex: none;
    width: var(--print-floor-width, 700px);
    height: var(--print-floor-height, 700px);
    zoom: var(--print-floor-zoom, 1);
  }
}
@media print and (orientation: landscape) {
  .floor-map .floor {
    height: var(--print-floor-height, 620px);
    zoom: var(--print-floor-zoom-landscape, 1);
  }
}
</style>


